import type { CommerceClient, SessionInfo } from '@altazion/commerce-sdk-core'

import {
  type AltazionModuleDefinition,
  type AltazionSuccessEventKind,
} from '../altazion-engine'

export type AltazionSessionActionName = 'getSession'

export const sessionModuleDefinition: AltazionModuleDefinition<'session', AltazionSessionActionName, SessionInfo> = {
  moduleName: 'session',
  actionAttribute: 'hx-altazion-session-action',
  parseAction(actionValue: string): AltazionSessionActionName {
    switch (actionValue) {
      case 'getSession':
        return actionValue
      default:
        throw new Error(`Unsupported session action: ${actionValue}`)
    }
  },
  execute(client: CommerceClient, action: AltazionSessionActionName): Promise<SessionInfo> {
    switch (action) {
      case 'getSession':
        return client.session.getSession()
    }
  },
  successEventKind(): AltazionSuccessEventKind {
    return 'loaded'
  },
}